<section>
  <app-form-header></app-form-header>
  <div class="row">
    <div class="col-12">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ 'COMMON.COMPANY' | translate }}</th>
          </tr>
        </thead>
        <tbody class="table-striped"></tbody>
        @for (company of companies; track company) {
          <tr class="cRow" (click)="companySelected(company)">
            <td>
              <div class="cNo">{{ company.number }}</div>
              <div class="cNm">{{ company.name }}</div>
            </td>
          </tr>
        }
      </table>
    </div>
  </div>
</section>
